import { jsx as _jsx } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { useSelector, useDispatch } from 'react-redux';
import { FiltersEmptyResult } from '../../components/lister/deprecated/empty-result/FiltersEmptyResult';
import { InStoreFilterEmptyResult } from '../../components/lister/deprecated/empty-result/InStoreFilterEmptyResult';
import { ListerEmptyResult } from '../../components/lister/deprecated/empty-result/ListerEmptyResult';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { filterActions } from '../../redux/filter/actions/FilterActions.creators';
import { makeGetFlattenedActiveFiltersState, makeGetProductSearchInformationState, makeGetLoadingState, makeGetInStoreFilterState, makeGetParentPage, } from '../../redux/lister/selectors/ListerSelector';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { makeGetStoreId } from '../../redux/url/selectors/UrlSelectors';
export const ListerEmptyResultContainer = () => {
    const { pageInfo, mainWebShop, feature_toggles } = useAemConfig();
    const { itemCount } = useSelector(makeGetProductSearchInformationState());
    const isLoading = useSelector(makeGetLoadingState());
    const activeFilters = useSelector(makeGetFlattenedActiveFiltersState());
    const activeStoreId = useSelector(makeGetStoreId());
    const inStoreFilter = useSelector(makeGetInStoreFilterState());
    const parentPage = useSelector(makeGetParentPage());
    const dispatch = useDispatch();
    const noResults = itemCount === 0;
    const hasActiveFilters = Boolean(activeFilters.length);
    const openInStoreFilterPopup = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(analyticsActions.storeFilterModified());
    };
    const removeAllActiveFilters = () => {
        dispatch(filterActions.removeAllFilters());
    };
    const updateStoreId = (storeId) => {
        dispatch(urlActions.updateStoreId(storeId));
    };
    if (feature_toggles.lister_in_store_filter && noResults && !isLoading && activeStoreId) {
        return (_jsx(InStoreFilterEmptyResult, { activeStoreId: activeStoreId, inStoreFilter: inStoreFilter, handleOpenPopup: openInStoreFilterPopup, removeAllActiveFilters: removeAllActiveFilters, updateStoreId: updateStoreId }));
    }
    if (noResults && !isLoading && hasActiveFilters) {
        return _jsx(FiltersEmptyResult, { removeAllActiveFilters: removeAllActiveFilters, mainWebShop: mainWebShop });
    }
    return (pageInfo.isCategoryPage || pageInfo.isBrandAsCategoryPage) && noResults && !isLoading && !hasActiveFilters ? (_jsx(ListerEmptyResult, { parentPageHref: parentPage === null || parentPage === void 0 ? void 0 : parentPage.href, parentPageTitle: parentPage === null || parentPage === void 0 ? void 0 : parentPage.title, mainWebShop: mainWebShop })) : null;
};
